if (!customElements.get('dc-article-sharing')) {
  customElements.define('dc-article-sharing', class extends HTMLElement {
    connectedCallback() {
      if (this.copyHandler) return;
      this.copyHandler = async (event) => {
        const button = event.target.closest('[data-copy-link]');
        if (!button || !this.contains(button)) return;
        const input = this.querySelector('[data-share-url]');
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(input.value);
          button.querySelector('[data-copy-label]').textContent = this.dataset.copied;
          status.textContent = this.dataset.copied;
        } catch {
          this.querySelector('[data-manual-copy-field]').hidden = false;
          status.textContent = this.dataset.manualCopy;
          input.focus();
          input.select();
        }
      };
      this.addEventListener('click', this.copyHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.copyHandler);
      this.copyHandler = null;
    }
  });
}


if (!customElements.get('dc-article-sidebar')) {
  customElements.define('dc-article-sidebar', class extends HTMLElement {
    connectedCallback() {
      this.sidebar = this.closest('.dc-article__sidebar');
      this.main = this.closest('.dc-article__layout')?.querySelector('.dc-article__main');
      if (!this.sidebar || !this.main) return;
      this.queueUpdate = () => {
        if (!this.isConnected || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const anchor = this.main.querySelector('.article-template__hero-container') || this.main.querySelector('.article-template__content') || this.main;
          const offset = Math.max(0, Math.round(anchor.getBoundingClientRect().top - this.main.getBoundingClientRect().top));
          this.sidebar.style.setProperty('--dc-article-sidebar-start', `${offset}px`);
        });
      };
      this.observer = new ResizeObserver(this.queueUpdate);
      this.observer.observe(this.main);
      this.queueUpdate();
      document.fonts.ready.then(() => this.queueUpdate());
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
